import script from "./configurationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./configurationPage.vue?vue&type=script&setup=true&lang=js"

import "./configurationPage.vue?vue&type=style&index=0&id=0daaab9c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0daaab9c"]])

export default __exports__